import { createBrowserRouter, Outlet, redirect } from "react-router";

import { Layout } from "./lib/components/layout";
import { getLoginToken } from "./lib/utils/local-storage.helpers";
import { CodePage } from "./pages/code.page";
import { LoginPage } from "./pages/login.page";
import { VerifyToken } from "./pages/verify-token.page";

export const router = createBrowserRouter([
  {
    id: "layout",
    element: (
      <Layout>
        <Outlet />
      </Layout>
    ),
    children: [
      {
        path: "/",
        element: <CodePage />,
        loader: () => {
          if (!getLoginToken()) {
            return redirect("/login");
          }
          return null;
        },
      },
      {
        path: "/login",
        element: <LoginPage />,
        loader: () => {
          if (getLoginToken()) {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "/verify/token",
        element: <VerifyToken />,
        loader: ({ request }) => {
          if (getLoginToken()) {
            return redirect("/");
          }
          const url = new URL(request.url);
          const companyIdParam = url.searchParams.get("companyId");
          const companyId = companyIdParam ? parseInt(companyIdParam) : null;
          if (!companyId) {
            return redirect("/login");
          }
          return { companyId };
        },
      },
      {
        path: "*",
        loader: () => redirect("/login"),
      },
    ],
  },
]);
